import ISessionPersistenceControlStrategy from "./ISessionPersistenceControlStrategy";

class AllSessionChangesStrategy implements ISessionPersistenceControlStrategy {

    // Override
    includeItemStateUpdate(): boolean {
        return true;
    }

    // Override
    includeItemUpdated(): boolean {
        return true;
    }
}

export default AllSessionChangesStrategy;
